import React from "react";
import { Button, ButtonGroup, Input } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

const LoginPage = () => {
    const {
        handleSubmit,
        control,
        register,
        reset,
        formState: { errors },
    } = useForm();
    const onSubmit = React.useCallback((values) => {
        console.log(values);
        reset();
    }, []);
    return (
        <div className="px-6">
            <form onSubmit={handleSubmit(onSubmit)}>
                <input defaultValue="test" {...register("example")} />
                <label>Tên đăng nhập h</label>
                <Input />

                <input {...register("exampleRequired", { required: true })} />
                {errors.exampleRequired && <span>This field is required</span>}

                <input type="submit" />
            </form>
        </div>
    );
};

export default LoginPage;
